import Icon from '../components/Icon.vue'

Icon.register({
  receipt: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M358.4 3.2L320 48 265.6 3.2A15.9-15.9 0 0 1 246.4 3.2L192 48 137.6 3.2A15.9-15.9 0 0 1 118.4 3.2L64 48 25.6 3.2C15-4.7 0 2.8 0 16V496C0 509.2 15 516.7 25.6 508.8L64 464 118.4 508.8A15.9-15.9 0 0 1 137.6 508.8L192 464 246.4 508.8A15.9-15.9 0 0 1 265.6 508.8L320 464 358.4 508.8C368.9 516.7 384 509.2 384 496V16C384 2.8 369-4.7 358.4 3.2zM320 360C320 364.4 316.4 368 312 368H72C67.6 368 64 364.4 64 360V344C64 339.6 67.6 336 72 336H312C316.4 336 320 339.6 320 344V360zM320 264C320 268.4 316.4 272 312 272H72C67.6 272 64 268.4 64 264V248C64 243.6 67.6 240 72 240H312C316.4 240 320 243.6 320 248V264zM320 168C320 172.4 316.4 176 312 176H72C67.6 176 64 172.4 64 168V152C64 147.6 67.6 144 72 144H312C316.4 144 320 147.6 320 152V168z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/receipt.js
// module id = RWYA
// module chunks = 144